export default {
  // 上课-课程列表_杨武
  getCourse(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/course/getCourse',
      params,
    });
  },
  // 上课日期（C端）_杨武
  getCourseDate(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/course/getCourseDate',
      params,
    });
  },
  // 班级详情-排课_刘鹏
  // classInfo(params) {
  //   return app.http.ajax({
  //     method: 'get',
  //     url: '/cs-edu/classInfo/selectClassInfo',
  //     params,
  //   });
  // },
  archivesGrowUpDetail(params) {
    // 成长记录详情
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/archivesGrowUp`,
      params: params,
    });
  },
  findStudentInClass() {
    //学员在读记录
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/student/findStudentInClass',
    });
  },
  // 获取家长端首页的动态信息-杨武
  findDynamicInfo(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-edu/dynamicInfo/findDynamicInfo',
      params,
    });
  },

  // 学员端首页约课列表
  homeReserve(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/course/homeReserve',
      params,
    });
  },
  // 学员端约课日期
  getReserveDate(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/course/getReserveDate',
      params,
    });
  },
  // 学员端约课列表
  studentReserveList(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/course/studentReserveList',
      params,
    });
  },
  // 学员端约课
  studentReserve(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-edu/course/studentReserve',
      params,
    });
  },
  // 学员端预约记录
  studentReserveRecord(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-edu/course/studentReserveRecord',
      params,
    });
  },
  // 学员端取消预约
  studentCancelReserve(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/course/studentCancelReserve',
      params,
    });
  },

  // 新增回复
  createArchivesReply(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-edu/archives/createArchivesReply',
      params,
    });
  },
  // 删除回复
  deleteArchivesReply(id) {
    return app.http.ajax({
      method: 'DELETE',
      url: `/cs-edu/archives/deleteArchivesReply?archivesRecordId=${id}`,
    });
  },
  // 获取回复列表
  getArchivesReplyPage(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-edu/archives/getArchivesReplyPage',
      params,
    });
  },

  // 获取测评详情
  getArchivesStageTest(params) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/archivesStageTest/get`,
      params: params,
    });
  },

  // 获取通知列表
  noticePage(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/notice/noticePage`,
      params: params,
    });
  },

  // 通知详情_方季惟
  noticeInfo(id) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/notice/info?id=${id}`,
    });
  },
  // 确认收到通知_方季惟
  noticeConfirm(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/notice/confirm',
      params,
    });
  },

  // 获取未读通知数量_方季惟
  getReceiverNoticeData() {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/notice/getReceiverNoticeData`,
    });
  },

  // 获取成长档案(动态)
  getArchivesPage(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/archives/getPage`,
      params: params,
    });
  },
  // 查询档案记录类型(分页)_李祥达
  archivesTypeList(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/archivesType/page`,
      params: params,
    });
  },

  // 获取收据快照
  getPrintSnap(id, companyId) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/public/receipt/snapInfoByPaymentGroupId?paymentGroupId=${id}&companyId=${companyId}`,
    });
  },
  // 学员卡包
  findStudentCard(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/parent/cardInfo/findStudentCard`,
      params: params,
    });
  },
  // 学员卡包详情
  findStudentCardById(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/parent/cardInfo/findStudentCardById`,
      params: params,
    });
  },
  // 学员卡包课时明细
  findCardCourseAmountDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/parent/cardInfo/findCardCourseAmountDetail`,
      params: params,
    });
  },
  // 学员卡包购买记录
  findStudentCardBuyRecord(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/parent/cardInfo/findStudentCardBuyRecord`,
      params: params,
    });
  },
  // 学员卡包操作记录
  findStudentCardOperationRecord(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/parent/cardInfo/findStudentCardOperationRecord`,
      params: params,
    });
  },
  // 获取学员汇总点名数据-杨武
  findCourseRollCallCount(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/parent/courseSign/findCourseRollCallCount`,
      params: params,
    });
  },
  
  // 获取指定学员所有点名明细-杨武
  findStudentRollCall(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/parent/courseSign/findStudentRollCall`,
      params: params,
    });
  },
  // 学员就读记录
  findSchoolRecord(params) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/parent/student/findSchoolRecord`,
      params: params,
    });
  },

  myCommentPage(params) {
    //学员点评列表-杨武
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/comment/myCommentPage',
      params,
    });
  },
  commentDetail(params) {
    //课堂-人员点评详情（机构端和家长端公用）-杨武
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/comment/commentDetail',
      params,
    });
  },
  // 点评新增回复_李祥达
  createCommentReply(params) {
    //课堂-人员点评详情（机构端和家长端公用）-杨武
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/comment/createCommentReply',
      params,
    });
  },
  // 点评消息回复列表_李祥达
  getCommentReplyRecordPage(params) {
    //课堂-人员点评详情（机构端和家长端公用）-杨武
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/comment/getCommentReplyRecordPage',
      params,
    });
  },
  // 点评删除回复_李祥达
  deleteCommentReply(id) {
    //课堂-人员点评详情（机构端和家长端公用）-杨武
    return app.http.ajax({
      method: 'DELETE',
      url: `/cs-edu/comment/deleteCommentReply?commentReplyRecordId=${id}`,
    });
  },
  // 答卷详情_方季惟
  answerInfo(id) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/qanda/answerInfo?id=${id}`,
    });
  },
  // 家长回评_方季惟
  answerReview(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/comment/review',
      params,
    });
  },
  // 问卷详情_方季惟
  getQandaInfo(id) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/qanda/info?id=${id}`,
    });
  },

  // 学员分享加分_钟军
  studentShare(params) {
    return app.http.ajax({
      method: 'POST',
      url: `/cs-edu/student/studentShare`,
      params: params,
    });
  },

  //  订单分页列表_收费
  getParentOrderInfoPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/parent/orderInfo/pageAdbOrder',
      params,
    });
  },
  // 订单详情_ 收费、转课
  getParentOrderInfo(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/parent/orderInfo/get',
      params,
    });
  },

  // 查询收据信息
  findReceipt(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/public/receipt/findReceipt',
      params,
    });
  },
  // 订单详情_ 退费、结转详情
  getParentOrderRefundDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/parent/orderInfo/getOrderRefundDetail',
      params,
    });
  },

  // 获取公众号二维码_方季惟
  getWxMpCode() {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/receiptTemplate/getWxMpCode',
    });
  },
  // 提交请假申请_毛新武
  leaveStudent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/leave/student',
      params,
    });
  },
  // 查询请假详情_毛新武
  getLeaveStudent(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/leave/student',
      params,
    });
  },
  // 获取请假列表_毛新武
  leaveStudentList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/leave/student/list',
      params,
    });
  },
  leaveStudentWithDraw(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/leave/student/withdraw',
      params,
    });
  },
  // 就读课程
  findStudentAttendCourse(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/parent/courseStudent/findStudentAttendCourse',
      params: params,
    });
  },
  // 查询机构配置
  getCompanyRule(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/leave/student/companyRule',
      params: params,
    });
  },
  // 电子钱包
  findStudentWallet() {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/student/findStudentWallet',
    });
  },
  // 查询学员积分
  promotionValidPage(params){
    return app.http.ajax({
      method: 'post',
      url: '/cs-edu/promotion/validPage',
      params,
    });
  },
  // 计算实付金额__刘鹏  
  utilsCalculatePayFact(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-edu/utils/calculate/payFact',
      params,
    });
  },
  // 家长端查看机构积分规则
  findMemberPointRuleList(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-edu/student/findMemberPointRuleList',
      params,
    });
  },
  // 合同详情
  contractDetail(params){
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/public/contract/student/detail',      
      params,
    });
  },
  // 合同签署
  contractSign(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-edu/public/contract/student/sign',
      params,
    });
  },
  // 测评报告详情
  evaluationInfo(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-edu/evaluation/student/info',      
      params,
    });
  },
  // 测评报告趋势数据
  evaluationTrend(params) {
    return app.http.ajax({
        method: 'POST',
        url: '/cs-edu/evaluation/trend',
        params,
    });
  },
};
